import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import { hashSettled } from 'rsvp';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

export default class WizardRoute extends Route {
	@service('billing') declare billingService: Service.Billing;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/templates') declare mmTemplatesService: Service.ModelManager.Templates;
	@service('model-manager/metrics') declare mmMetricsService: Service.ModelManager.Metrics;
	@service('model-manager/scripts') declare mmScriptsService: Service.ModelManager.Scripts;
	@service('model-manager/custom-queries')
	declare mmCustomQueriesService: Service.ModelManager.CustomQueries;
	@service('wizard') declare wizardService: Service.Wizard;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'wizard';

		const promises: Record<string, Promise<unknown>> = {};

		promises.initial = this.navigationService.initialRequestsPromise;
		promises.publictemplates = this.mmTemplatesService.requestBoardPublicTemplates();
		promises.scripts = this.mmScriptsService.requestScripts();
		promises.queries = this.mmCustomQueriesService.requestCustomQueries();
		promises.metrics = this.mmMetricsService.requestMetrics();

		// promises.unresolved = (new Promise(function(){})); // forever unresolved - to test skeleton screens

		return hashSettled(promises);
	}

	override afterModel() {
		const feature = BillingFeature.BOARDS;
		if (!this.billingService.checkIfCan(feature)) {
			this.navigationService
				.replaceRoute('index')
				.followRedirects()
				.then(() => {
					this.billingService.handleLimitations(feature);
				});
			return;
		}
	}

	@action
	override willTransition(transition: Transition) {
		this.wizardService.title = null;

		if (!transition.targetName?.includes('wizard')) {
			this.wizardService.cleanUp();
		}
	}
}
